import { styled } from 'styled-components'

export const IconStyle = styled.img`
  width: 30px;
  height: 30px;
`

export const SideBar = styled.img`
  width: 26px;
  height: 30px;
`

export const IconesAvancarVoltar = styled.img`
  width: 15px;
  height: 20px;
`
